module.exports = __webpack_public_path__ + "img/DA.1657c5aa.png";